export const dislikeClipFeedbackValue = [
  "It's an advertisement",
  "It's not interesting",
  'It cuts off mid sentence',
  'other reason',
] as const;
